<template>
<div class="ai-chat-popup-contain" v-if="show">
  <div v-if="!this.$store.state.robotInfo.show_win" class="ai-icon-box ai-icon-box-tom" @click="showFun()">
    <video src="/static/video/ai_v2/ai-logo.webm"
       webkit-playsinline='true'
       playsinline='true'
       x5-video-player-type='h5'
       x5-video-player-fullscreen='true'
       x-webkit-airplay='true'
       muted
       loop
       autoplay
       class="ai-v-btn"
    ></video>
    <img src="/static/video/ai_v2/robot1.gif" alt="" class="ai-v-btn-tom">
  </div>

  <div v-else class="ai-icon-box" @click="showFun()">
    <img src="/static/images/ai_v2/icon_hide_popup.png" alt="" class="ai-v-btn">
  </div>


  <div v-if="this.$store.state.robotInfo.show_win" class="ai-chat-popup-box">
    <div class="ai-chat-head-box">
      <img src="/static/images/ai_v2/icon_ai_a.png" alt="">
      Smartz AI Agent
    </div>

    <div class="ai-chat-body-box" id="chat-record-list">

      <div
        class="a-chat-record-item-obox"
        v-for="(item, key) in chat_list"
        :key="key"
      >

        <div v-if="item.type === 'ai'" class="a-chat-record-item-box">
          <div class="a-record-box">
            <div class="a-u-box">
              <img src="/static/images/ai_v2/icon_ai.png" alt="">
            </div>
            <div class="a-chat-text-box">
              {{item.text}}
            </div>
          </div>
        </div>
        <div v-else-if="item.type === 'user'" class="a-chat-record-item-box a-user-chat">
          <div class="a-record-box">
            <div class="a-chat-text-box">
              {{item.text}}
            </div>
            <div class="a-u-box">
              <img src="/static/images/ai_v2/icon_user.png" alt="">
            </div>
          </div>
        </div>
      </div>

    </div>

    <div class="ai-chat-foot-box">
      <div class="audio-input-btn" @click="speekFun()">
        <img src="/static/images/ai_v2/icon_audio_input.png" alt="">
      </div>
      <div class="input-box">
        <input type="text" v-model="input_data" :disabled="waiting_rep" @keydown.enter="sendFun">
      </div>
      <div class="send-btn" @click="sendFun">
        <img src="/static/images/ai_v2/icon_send.png" alt="">
      </div>
    </div>

    <div v-if="is_audio_input" class="ai-chat-speek-contain">
      <div class="q-out-box">
        <!--          <img width="200" src="/static/images/ai_v2/user_speek.png" alt="">-->
        <div v-show="listener_audio_input" class="q-ix-box">
          <video src="/static/video/ai_v2/user_speek.webm?v=1.0.0"
             webkit-playsinline='true'
             playsinline='true'
             x5-video-player-type='h5'
             x5-video-player-fullscreen='true'
             x-webkit-airplay='true'
             muted
             loop
             autoplay
          ></video>
          <div class="e-un-evt"></div>
          <p>Please Speaking...</p>
        </div>
        <div v-show="!listener_audio_input" class="q-ix-box">
          <video src="/static/video/ai_v2/ai_speek.webm?v=1.0.0"
             webkit-playsinline='true'
             playsinline='true'
             x5-video-player-type='h5'
             x5-video-player-fullscreen='true'
             x-webkit-airplay='true'
             muted
             loop
             autoplay
          ></video>
          <div class="e-un-evt"></div>
          <p>I am Answering...</p>
        </div>
        <div class="q-btn-box">
          <button class="q-btn" @click="stopListening()">End Chat</button>
        </div>
      </div>
    </div>
  </div>


</div>
</template>

<script>
import {chatStart, getAchatRecord, startNew} from "../../api/aiChat";
import  { mapState } from 'vuex';
export default {
  name: "index",
  data(){
    return {
      show: false,
      // show_win: false,
      chat_list: [],
      input_data: '',
      waiting_rep: false, //等待回应
      brand_chat_session_id: '',
      e_recognition: null,
      isSpeaking: false,
      synth: window.speechSynthesis,
      is_audio_input: false,
      listener_audio_input: false,
      // speek_data: '',
    }
  },
  mounted() {
    this.show = true;
    // this.initFun();
  },
  computed: {
    ...mapState({
      show_win: state => state.robotInfo.show_win,
    })
  },
  // watch: {
  //   show_win() {
  //     let val = this.$store.state.robotInfo.show_win;
  //     console.log(val, '148')
  //     if(val) {
  //       this.show_win = false;
  //     } else {
  //       this.show_win = true;
  //     }

  //   }
  // },
  methods:{
    showFun(){
      this.$store.dispatch('init_robotinfo')
      // this.show_win = !this.show_win;


      if(this.brand_chat_session_id === ''){
        this.initFun();
      }
    },
    async sendFun(type='text'){
      if(this.input_data){

        setTimeout(() => {
          this.input_data = '';
        },200)

        let data = {type: 'user', text: this.input_data};
        this.chat_list = [...this.chat_list, data ];

        setTimeout(() => {
          document.querySelector('#chat-record-list').scrollTop = document.querySelector('#chat-record-list').scrollHeight;
        },50)

        this.waiting_rep = true;

        let res = await chatStart(this.brand_chat_session_id, this.input_data);
        let {response} = res;
        if(type === 'audio'){
          this.textToAudioFun(response);
        }
        let data_ai = {type: 'ai', text: response};
        this.chat_list = [...this.chat_list, data_ai ];
        this.waiting_rep = false;

        setTimeout(() => {
          document.querySelector('#chat-record-list').scrollTop = document.querySelector('#chat-record-list').scrollHeight;
        },50)
      }

    },
    async initFun(){
      let new_res = await startNew();
      let {brand_chat_session_id} = new_res;
       //"2032341f-8501-46bc-b021-5ae414092784";
      if(brand_chat_session_id){
        this.brand_chat_session_id = brand_chat_session_id;
      }

    },
    speekFun(){
      this.is_audio_input = true;
      this.listener_audio_input = true;
      const _self = this;
      if ('webkitSpeechRecognition' in window) {
        const recognition = new webkitSpeechRecognition();

        // 设置识别语言，这里设置为中文 "en-US" 表示美国英语，"cmn-Hans-CN" 表示简体中文。
        recognition.lang = 'en-US';

        // 连续模式，可以持续接收语音
        recognition.continuous = true;

        // 开始监听用户语音
        recognition.onresult = function(event) {
          const last = event.results.length - 1;
          const text = event.results[last][0].transcript;
          console.log(`text: ${text}`);
          // resultDiv.textContent = text;
          // _self.text_arr.push(text)
          // _self.logs_arr.push(`${_self.timeLG()}: 内容（${text}）`)

          if(!_self.isSpeaking){
            _self.input_data = text;
            _self.sendFun('audio');
            _self.listener_audio_input = false;
          }

        };

        // 识别结束时的处理
        recognition.onend = function() {
          console.log('语音识别结束');
          // _self.logs_arr.push(`${_self.timeLG()}: 语音识别结束`)
          // _self.is_speak = false;
        };

        //
        recognition.onerror = function(event) {
          let error = event.error
          console.log(error)

          _self.is_audio_input = false;
        }

        // 点击按钮开始录音
        // startButton.addEventListener('click', () => {
        //     recognition.start();
        //     console.log('开始录音');
        //     _self.logs_arr.push(`${_self.timeLG()}: 开始录音`)
        //     _self.is_speak = true;
        // });

        _self.e_recognition = recognition;

        _self.e_recognition.start();
      } else {
        alert('Current browser does not support voice recognition');
      }
    },
    stopListening() {
      if (this.e_recognition && this.e_recognition.stop) {
        this.e_recognition.stop();
        this.is_audio_input = false;
      }

      this.is_audio_input = false;

      this.stopSpeaking();
    },
    textToAudioFun(text){
      if ('speechSynthesis' in window) {
        const utterance = new SpeechSynthesisUtterance(text);

        // 设置语言为中文
        utterance.lang = 'en-US';

        // 开始朗读
        this.isSpeaking = true;
        this.synth.speak(utterance);

        // 监听朗读结束事件
        utterance.onend = () => {
          this.isSpeaking = false;
          this.listener_audio_input = true;
        };

        // 监听朗读错误事件
        utterance.onerror = (event) => {
          console.error('朗读出错:', event.error);
          this.isSpeaking = false;
        };
      } else {
        alert("Current browser does not support Web Speech API!");
      }
    },
    stopSpeaking() {
      if ('speechSynthesis' in window) {
        this.synth.cancel();
        this.isSpeaking = false;
      }
    }

  }
}
</script>

<style lang="scss" scoped>
@import '@/assets/css/common.scss';
@import "index.scss";
</style>



// WEBPACK FOOTER //
// src/modules/aiChatPopup/index.vue